export enum Origin {
    CHECK_OUT = "checkout",
    MY_CREDIT_CARD = 'mycreditcards'
}